import { render, staticRenderFns } from "./AddProductsModal.vue?vue&type=template&id=5a6f2b79&"
import script from "./AddProductsModal.vue?vue&type=script&lang=js&"
export * from "./AddProductsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports